import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Sidebar from '../components/Sidebar';
import Topbar from '../components/Topbar';
import logoamerisa from '../assets/logoamerisa.png';

const Home = () => {
  const [sidebarOpen, setSidebarOpen] = useState(true);
  const [activeItem, setActiveItem] = useState('OrderTrack');
  const [userName, setUserName] = useState('');
  const navigate = useNavigate();

  const handleLogout = () => {
    console.log('Logout clicked!');
    localStorage.clear();
    navigate('/login', { replace: true });
  };

  useEffect(() => {
    const fetchUserInfo = async () => {
      try {
        const token = localStorage.getItem('token');
        if (!token) {
          navigate('/login', { replace: true });
          return;
        }

        const response = await fetch(`${process.env.REACT_APP_API_URL}/me`, {
          headers: {
            'Authorization': `Bearer ${token}`,
          },
        });

        if (!response.ok) {
          throw new Error('Error al obtener la información del usuario');
        }

        const userData = await response.json();
        setUserName(userData.name);
      } catch (error) {
        console.error('Error:', error);
        navigate('/login', { replace: true });
      }
    };

    fetchUserInfo();
  }, [navigate]);

  return (
    <div className="flex">
      {/* Sidebar */}
      <Sidebar
        isOpen={sidebarOpen}
        setSidebarOpen={setSidebarOpen}
        activeItem={activeItem}
        setActiveItem={setActiveItem}
        onLogout={handleLogout}
      />

      <div
        className={`transition-all duration-300 flex-1 ${
          sidebarOpen ? 'ml-64' : 'ml-16'
        } bg-gray-100 min-h-screen p-6`}
      >
        {/* Replace hardcoded top bar with Topbar component */}
        <Topbar  />

        {/* Contenedor principal */}
        <div className="mt-6 flex">
          {/* Columna para el mensaje de bienvenida */}
          <div className="flex-1 flex items-center justify-center">
            {userName && (
              <div className="text-center">
                <h2 className="text-4xl font-bold text-sky-900 mb-2">
                  ¡Bienvenido, <span className="text-orange-500">{userName}</span>!
                </h2>
                <p className="text-xl text-gray-600">
                  Esperamos que tengas un gran día en Amerisa.
                </p>
              </div>
            )}
          </div>

          {/* Columna para el post de LinkedIn */}
          <div className="flex-1 flex justify-end">
            <div className="w-full max-w-2xl">
            <iframe src="https://www.linkedin.com/embed/feed/update/urn:li:ugcPost:7308544440770457600" height="1024" width="504" frameborder="0" allowfullscreen="" title="Publicación integrada"></iframe>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Home;